import { ReportList } from './ReportList';

export default ReportList;
